import { RootState } from '@/domain/store';

import { VenueMonthDeclaration } from './entities/project-venue-month-declaration';

export const selectProjectVenuesMonthDeclarationByMonth =
  (month: string) =>
  (state: RootState): VenueMonthDeclaration => {
    return state.ProjectVenueMonthDeclaration.byMonth[month];
  };

export const selectIsFetchingMonthDeclarations = (state: RootState) => {
  return state.ProjectVenueMonthDeclaration.isFetching;
};

export const selectIsSubmitingMonthDeclarations = (state: RootState) => {
  return state.ProjectVenueMonthDeclaration.isSubmiting;
};

export const selectProjectVenuesMonthDeclaration = (state: RootState) => {
  return state.ProjectVenueMonthDeclaration.byMonth;
};
